export function VendorBranchPaymentCtrl (
  $scope,
  inheritorApi,
  payment,
  settings,
  vendor,
  Vendor
) {
  $scope.payment  = payment;
  $scope.settings = settings;
  $scope.vendor   = vendor || {};

  inheritorApi.inheritCtrl('VendorBranchPaymentLiteCtrl', $scope);
}
